"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleTimeValidation = handleTimeValidation;
function handleTimeValidation(newValue, setErrorMessage, setInputValue) {
    // Check if the input has at least 2 characters
    if (newValue.length >= 2) {
        // Parse the first 2 characters as hours
        var hours = parseInt(newValue.substring(0, 2));
        // Validate the hours: should be between 1 and 12
        if (isNaN(hours) || hours < 1 || hours > 12) {
            setErrorMessage('Invalid hour');
            return;
        }
    }
    // Check if the input has at least 4 characters
    if (newValue.length >= 4) {
        // Validate the format of the input: should have a colon (:) at the right position
        if ((newValue[2] !== ':' && newValue[1] !== ':') || (newValue[2] === ':' && newValue[1] === ':')) {
            setErrorMessage('Invalid format');
            return;
        }
    }
    // Check if the input has at least 5 characters
    if (newValue.length >= 5) {
        // Parse the last 2 characters as minutes
        var minutes = parseInt(newValue.substring(3, 5));
        // Validate the minutes: should be between 0 and 59
        if (isNaN(minutes) || minutes < 0 || minutes > 59) {
            setErrorMessage('Invalid minutes');
            return;
        }
    }
    // Check if the input has at least 7 characters
    if (newValue.length >= 7) {
        // Validate the AM/PM part and ensure there's a space after the time
        if (newValue[2] === ':' && (newValue[6] !== 'A' && newValue[6] !== 'P' && newValue[7] !== 'M')) {
            setErrorMessage('Invalid AM/PM, Add space after time');
            return;
        }
        if (newValue[3] === ':' && (newValue[7] !== 'A' && newValue[7] !== 'P' && newValue[8] !== 'M')) {
            setErrorMessage('Invalid AM/PM, Add space after time');
            return;
        }
        // Convert AM/PM to uppercase and truncate the input to 8 characters
        newValue = newValue.substring(0, 8).toUpperCase();
    }
    // Set the cleaned and validated value, and clear any previous error message
    setInputValue(newValue);
    setErrorMessage(null);
}
// The current behaviour of this component works well with format of 00:00 AM/PM values, not validating correctly when 0:00 AM/PM is entered 
// This will be important to solve. It should let you input 230 and then take you to 2:30PM. -> 
// This happens because we are not allowing user to enter hours before ":" >= than 12 (12 hours format), so if user enters 13 it is invalid hour
// may be regex can be applied to autoformat
// The keyboard function is not working - but this can be layer 2 - 
// [need to figure out functionality, right now if Enter is pressed it selects nearest time if to current time If incorrect time is entered, 
// and if right time is entered blur gets called]
